import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import NavBar from "./Navbar";
import ScrollToTop from "./ScrollToTop";
import Contact from "./Contact";
import Home from "./Home";
import Privacy from "./Privacy";
import Services from "./Services";
import Pricing from "./Pricing";
import Resources from "./Resources";
import About from "./About";
import BlogPost from "./BlogPost";
import Unauthorized from "./Unauthorized";
import NotFound from "./NotFound";
import GBPManagement from "./GBPManagement";
import Accounting from "./Accounting";
import Mortgage from "./Mortgage";
import Wealth from "./Wealth";
import Trial from "./Trial";
import LocalSEO from "./LocalSEO";
import DigitalGrowth from "./DigitalGrowth";
import WebManagement from "./WebManagement";
import WebsiteUptime from "./WebsiteUptime";
import OnePageSEO from "./OnePageSEO";
import WebSpeed from "./WebsiteSpeed";
import BlogContentWriting from "./BlogContentWriting ";

const App = () => {
  return (
    <div className="app-container">
      <Router>
        <NavBar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/trial" element={<Trial />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/services-for-accountants" element={<Services />} />
          <Route
            path="/services/local-seo-services-for-accountants"
            element={<LocalSEO />}
          />
          <Route
            path="/services/digital-growth-for-accountants"
            element={<DigitalGrowth />}
          />
          <Route
            path="/services/website-management-services-for-accountants"
            element={<WebManagement />}
          />
          <Route
            path="/services/website-uptime-monitoring-for-accountants"
            element={<WebsiteUptime />}
          />
          <Route
            path="/services/on-page-seo-for-accountants-and-accounting-firms"
            element={<OnePageSEO />}
          />
          <Route
            path="/services/website-speed-optimization-services-for-accountants"
            element={<WebSpeed />}
          />
          <Route
            path="/services/google-business-profile-management-services-for-accountants"
            element={<GBPManagement />}
          />
          <Route
            path="/services/blog-content-writing-service-for-accountants"
            element={<BlogContentWriting />}
          />

          <Route
            path="/services/accounting-bookkeeping"
            element={<Accounting />}
          />
          <Route path="/services/mortgage-brokers" element={<Mortgage />} />
          <Route path="/services/wealth-management" element={<Wealth />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/content/:slug" element={<BlogPost />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Router>
      <Analytics />
    </div>
  );
};

export default App;
